import {ChangeDetectorRef, Component, Inject, Input, OnInit} from '@angular/core';
import { AllService } from '../../../../services/all.service';
import { ModalService } from '../../../../services/modal.service';
import { IMessengerConnector } from '../../../../types/all.type';
import {InterfaceService} from '../../../../services/interface.service';
import {DcService} from '../../../../services/dc.service';

@Component({
  selector: 'app-message-pinned',
  templateUrl: './message-pinned.component.html',
  styleUrls: ['./message-pinned.component.scss']
})
export class MessagePinnedComponent implements OnInit {
  @Input() Service: IMessengerConnector;
  @Input() mode: 'full' | 'compact' = 'compact';

  constructor(
    private dcService: DcService,
    public interfaceService: InterfaceService,
    public allService: AllService,
    private cd: ChangeDetectorRef,
    public modalService: ModalService) {}

  ngOnInit(): void {}

  pinnedClose(): void {
    this.allService.arPinnedMessages = [];
    this.dcService.detectChanges$.next('messages-scroll');
    this.cd.detectChanges();
  }
  openMessages(): void {
    this.modalService.openModal('ModalMessagePinnedComponent', {
      messages: this.allService.arPinnedMessages,
      Service: this.Service
    });
  }
}
